import React from 'react'
import Skeleton from 'react-loading-skeleton'

const PaymentMethodSkeleton = () => {
  return <Skeleton width={'100%'} height={74} />
}

export default PaymentMethodSkeleton
